<div class="sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<ng-container *ngIf="claim.isModifiable">
		<ng-container *ngIf="isValidator; else notValidator">
			<ng-container *ngIf="claim.isDraft; else modifiable">
				<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
					[titleHeaderText]="'issue.register'|translate">
					<button type="button" mat-flat-button (click)="saveClaim($event, true)">
						<span translate>issue.save.as.drafts</span>
						<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
					</button>
					<button type="submit" mat-flat-button color="primary" (click)="saveClaim($event, false)">
						<span translate>issue.submit.quality.feedback</span>
					</button>
				</copo-panel-header>
			</ng-container>
			<ng-template #modifiable>
				<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
					[titleHeaderText]="'menu.modify.quality.issue'|translate">
					<button type="submit" mat-flat-button color="primary" (click)="saveClaim($event, false)">
						<span translate>issue.submit.quality.feedback</span>
					</button>
				</copo-panel-header>
			</ng-template>
		</ng-container>
		<ng-template #notValidator>
			<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()">
				<ng-container *ngIf="isDetector && claim.isDraft">
					<button type="button" mat-flat-button (click)="saveClaim($event, true)">
						<span translate>issue.save.as.drafts</span>
						<mat-icon class="save-icon" svgIcon="action_save"></mat-icon>
					</button>
				</ng-container>
			</copo-panel-header>
		</ng-template>
	</ng-container>
	<div class="copo-stepper-container copo-form-container">
		<copo-stepper [steps]="steps" (stepClicked)="onStepClicked($event)"></copo-stepper>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.type.of.request</div>
				<div class="label-info">{{ (claim.type === 'issue' ? 'claim.quality.issue' : 'claim.warning') |
					translate | uppercase }}</div>
			</div>
			<div class="copo-grid-row-column copo-label" *ngIf="claim.type === 'issue'">
				<div class="copo-label" translate>claim.claimtype.label</div>
				<div class="label-info">{{ (claim.claimType === 'ZL' ? 'claim.type.zl' : 'claim.type.zr') | translate | uppercase }}</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.customer.reference</div>
				<div class="label-info">{{ claim.reference || UNDERSCORE | uppercase}}</div>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.defect.type</div>
				<div class="label-info">{{ claim.defectDetailedRef ? (('defect.' + claim.defectDetailedRef) | translate | uppercase) : UNDERSCORE }}</div>
			</div>
			<div class="copo-grid-row-column" *ngIf="claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample">
				<div class="copo-label" translate>issue.sending.sample</div>
				<div class="label-info">{{ (claim.sampleTr !== 'not' ? 'global.yes' : 'global.no') | translate | uppercase }}</div>
			</div>
			<div class="copo-grid-row-column copo-grid-row-column-center">
				<div *ngIf="claim.defectDetailedRef === '' || !defectOptions[claim.defectDetailedRef]!.sample" translate>
					claim.no.sample.needed
				</div>
				<div *ngIf="claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample && claim.sampleTr !== 'not'">
					<div class="copo-label" translate>issue.contact.type</div>
					<div class="label-info">{{ ('claim.sample.' + claim.sampleTr) | translate | uppercase }}</div>
				</div>
			</div>
			<div class="copo-grid-row-column copo-label"
				*ngIf="claim.sampleTr === 'other' && claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample">
				<div class="copo-label" translate>issue.contact.info</div>
				<div class="label-info">{{ claim.sampleComment | uppercase }}</div>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>claim.impacted.quantity</div>
				<div class="label-info">{{ claim.quantityValue | copoNumber: 'weight' }}</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.unit</div>
				<div class="label-info">{{ unitBatchOptions[lowerCaseUnit(claim.quantityUnitTr)].label | translate | uppercase }}</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.contact.label</div>
				<div class="label-info">{{ (claim.wantVisit === false ? 'no' : 'yes') | uppercase }}</div>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>claim.attachments</div>
				<div *ngFor="let attachment of getAttachments(claim)">
					<a target="_blank"
						rel="noopener"
						[href]="getAttachmentUrl(claim.steeluserId!, attachment) | copoSafeUrl"
						(click)="showAttachment($event, attachment)"
						class="attachment-container" >{{attachment.name}}</a>
				</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>claim.comment</div>
				<div class="label-info label-info-pre">{{claim.shortDescription}}</div>
			</div>
		</div>
		<div class="copo-grid-row" *ngIf="claim.claimType === 'ZR'">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>claim.material.costs</div>
				<div class="label-info">{{claim.amountValue | copoNumber: 'amount'}}</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.currency</div>
				<div class="label-info">{{claim.amountUnitTr | uppercase}}</div>
			</div>
		</div>
		<div class="copo-grid-row" *ngIf="claim.haveAdditionalCosts">
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>claim.other.amount.cost</div>
				<div class="label-info">{{claim.otherCostAmount | copoNumber: 'amount'}}</div>
			</div>
			<div class="copo-grid-row-column copo-label">
				<div class="copo-label" translate>issue.currency</div>
				<div class="label-info">{{claim.amountUnitTr | uppercase}}</div>
			</div>
		</div>
	</div>
	<div class="main-batch-content" *ngIf="mainClaimBatchPair !== undefined">
		<div class="main-batch-quality-info-label" translate>quality.information</div>
		<div class="batch-steelgrade">
			<div class="main-batch-info-label" translate>issue.batch.steelgrade</div>
			<div>{{ mainClaimBatchPair.claimBatchFromApi.steelgradeDescription ? mainClaimBatchPair.claimBatchFromApi.steelgradeDescription :
				UNDERSCORE }}</div>
		</div>
		<div class="batch-dimension">
			<div class="main-batch-info-label" translate>issue.batch.dimension</div>
			<div>{{ mainClaimBatchPair.claimBatchFromApi | copoDimension }}</div>
		</div>
		<div class="batch-cdd">
			<div class="main-batch-info-label" translate>issue.batch.cdd</div>
			<div>{{ mainClaimBatchPair.claimBatchFromApi.cddWeek ? mainClaimBatchPair.claimBatchFromApi.cddWeek : UNDERSCORE }}</div>
		</div>
		<mat-icon class="main-batch-mill-icon" svgIcon="at_consignment"></mat-icon>
		<span>{{ mainClaimBatchPair.claimBatchFromApi.millDescription }}</span>
		<ng-container *ngIf="claim.claimType === 'ZR'">
			<div class="batch-customer-order">
				<div class="main-batch-info-label" translate>issue.batch.customer.order.number</div>
				<div>{{ mainClaimBatchPair.claimBatchFromApi.customerOrderNumber ? mainClaimBatchPair.claimBatchFromApi.customerOrderNumber : UNDERSCORE }}/{{ mainClaimBatchPair.claimBatchFromApi.customerOrderItemNumber ? mainClaimBatchPair.claimBatchFromApi.customerOrderItemNumber : UNDERSCORE }}</div>
			</div>
			<div class="batch-reference">
				<div class="main-batch-info-label" translate>issue.batch.number</div>
				<div>{{ mainClaimBatchPair.claimBatchFromApi.batchReference ? mainClaimBatchPair.claimBatchFromApi.batchReference : UNDERSCORE }}</div>
			</div>
		</ng-container>
	</div>
	<div *ngIf="mainClaimBatchPair !== undefined && mainClaimBatchPair.claimBatchFromApi !== undefined; else spinner" class="related-batch-list">
		<div class="related-batch related-batch-border">
			<mat-icon class="related-batch-icon" svgIcon="icon-batch"></mat-icon>
			<div class="related-batch-number">
				<div translate>issue.batch.number</div>
				<div>{{mainClaimBatchPair.claimBatchFromApi.batchReference}}</div>
			</div>
			<div class="related-batch-status">
				<div translate>issue.batch.status</div>
				<div>{{mainClaimBatchPair.claimBatchFromApi.statusDescription}}</div>
			</div>
			<a mat-button color="primary" class="related-batch-documents-link"
				[routerLink]="['/order-tracking/batch/card', mainClaimBatchPair.claimBatchFromApi.id]" fragment="documents">
				<span translate>issue.batch.commercial.documents</span>
				<mat-icon iconPositionEnd class="related-batch-documents-link-icon" color="accent" svgIcon="table_document">
				</mat-icon>
			</a>
			<div class="related-batch-quantity" *ngIf="claim.claimType === 'ZL'">
				<span class="related-batch-quantity-pill">{{ mainClaimBatchPair.issueBatch.claimedQuantityValue}} / {{ quantity(mainClaimBatchPair.issueBatch) }}</span>
			</div>
			<a class="related-batch-view-details-link" mat-button color="primary"
				[routerLink]="['/order-tracking/batch/card', mainClaimBatchPair.claimBatchFromApi.id]"
				target="_blank">
				<span translate>issue.batch.view-details</span>
				<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
			</a>
		</div>
		<div class="related-batch" *ngFor="let batch of selectedBatchPairList;let i = index ;" [hidden]="claim.claimType === 'ZR'">
			<mat-icon class="related-batch-icon" svgIcon="icon-batch"></mat-icon>
			<div class="related-batch-number">
				<div translate>issue.batch.number</div>
				<div>{{batch.claimBatchFromApi.batchReference}}</div>
			</div>
			<div class="related-batch-status">
				<div translate>issue.batch.status</div>
				<div>{{batch.claimBatchFromApi.statusDescription}}</div>
			</div>
			<a mat-button color="primary" class="related-batch-documents-link"
				[routerLink]="['/order-tracking/batch/card', batch.claimBatchFromApi.id]" fragment="documents">
				<span translate>issue.batch.commercial.documents</span>
				<mat-icon iconPositionEnd class="related-batch-documents-link-icon" color="accent" svgIcon="table_document">
				</mat-icon>
			</a>
			<div class="related-batch-quantity">
				<span class="related-batch-quantity-pill">{{ batch.issueBatch.claimedQuantityValue | copoNumber: 'weight' }} / {{ quantity(batch.issueBatch) }}</span>
			</div>
			<a class="related-batch-view-details-link" mat-button color="primary"
				[routerLink]="['/order-tracking/batch/card', batch.claimBatchFromApi.id]">
				<span translate>issue.batch.view-details</span>
				<mat-icon color="accent" svgIcon="md:chevron_right"></mat-icon>
			</a>
		</div>
	</div>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>